const API_BASE_URL = process.env.VITE_API_URL || "http://localhost:62274";

export const GENERATE_OPENAI_IMAGE_API_URL = `${API_BASE_URL}/generate-image/openai`;
export const IS_APPROPRIATE_API_URL = `${API_BASE_URL}/moderation/moderate`;
